import { getTimeTillEndOfDayMs } from '@helpers/utils/dates/getTimeTillEndOfDayMs';
import { useQuery } from '@tanstack/react-query';

import { fetchKeyValues } from '../../services/entity-report-service';

export const QUERY_KEY_VALUES = 'QUERY_KEY_VALUES';
export const useKeyValues = ({ entityTag }: { entityTag: string }) => {
  return useQuery({
    queryKey: [QUERY_KEY_VALUES, entityTag],
    queryFn: ({ signal }) => fetchKeyValues(entityTag, signal),
    staleTime: getTimeTillEndOfDayMs(),
  });
};
